import { FileExtractionFieldKey } from '../types/file-extraction-field-key.types';

export const normalizeExtractedValue = (
  key: FileExtractionFieldKey,
  value: string,
): string => {
  if (key === 'Sex') {
    if (value.toUpperCase() === 'M') return 'male';
    if (value.toUpperCase() === 'F') return 'female';
  }
  return value;
};
